import http from './http-common';

class GodownService {
    getAll() {
        return http.get("/godown");
    }

    getForList() {
        return http.get(`/godown/godownForList`);
      }    

    get(id) {
        return http.get(`/godown/${id}`);
    }

    create(data) {
        return http.post('/godown', data);
    }

    update(data) {
        return http.put(`/godown/update`, data);
    }

    delete(id) {
        return http.delete(`/godown/${id}`);
    }
}

export default new GodownService();